import React, {useMemo, useState} from "react";
import {FaMagnifyingGlass} from "react-icons/fa6";
import {getCurrentTaxYear} from "../../../helpers/utils/Utils";
import {
    getTaxRateYearValue,
} from "../../../helpers/utils/OrderDetailUtils";
import Modal from "../../../components/common/form/Modal";
import {DataTable} from "../../../components/common/datatable/DataTable";
import {DataTableColumn} from "../../../components/common/datatable/DataTableTypes";
import Form from "../../../components/common/form/Form";
import ButtonTray from "../../../components/common/form/ButtonTray";
import {useSearchAllJurisdictionQuery} from "../../data/jurisdiction/jurisdictionApi";
import {
    autoNationalCalculateSummaryRow,
    updateNationalSummarySectionRow
} from "../nationalEditor/TaxCertificate/TaxCertNationalUtil";


interface JurisdictionListModalProps {
    show: boolean;
    setShow: (value: boolean) => void;
    index: number;
    certificate: any;
    setCertificate: (certificate: any) => void;
    setUpdateTotalTaxValue?: (value: boolean) => void;
    showAccount: number;
    type: string;
    county: any;
    orderId?: number | null;
    setUpdatedAccountIndexList: any;
    setIsSavedResult: (value: boolean) => void;
}

export default function NationalJurisdictionListModal({
                                                  show,
                                                  setShow,
                                                  index,
                                                  certificate,
                                                  setCertificate,
                                                  setUpdateTotalTaxValue,
                                                  showAccount,
                                                  type,
                                                  county,
                                                  orderId = null,
                                                  setUpdatedAccountIndexList,
                                                  setIsSavedResult
                                              }: JurisdictionListModalProps) {

    const [jurisdictionName, setJurisdictionName] = useState<any>();
    const [id, setId] = useState("");
    const [collectorName, setCollectorName] = useState("");
    const [collectorId, setCollectorId] = useState("");
    const [nonCollecting, setNonCollecting] = useState(false);
    const [inActive, isInActive] = useState(false);
    const [taxRateList, setTaxRateList] = useState<any[]>([]);
    const [note, setNote] = useState<any[]>([]);
    const taxYear = useMemo(() => getCurrentTaxYear(), []);

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();

        if (jurisdictionName !== "" && collectorName !== "") {
            let clonedCertificate = structuredClone(certificate);
            const account = clonedCertificate.accounts[showAccount];
            const jurisdiction = account.jurisdictionList[index];

            if (type === 'jurisdiction') {
                Object.assign(jurisdiction, {
                    jurisdictionName,
                    jurisdictionId: id,
                    collectorName,
                    collectorId,
                    taxYear,
                    tax_rate_List: taxRateList,
                    tax_rate: taxRateList == null ? null : getTaxRateYearValue(taxRateList, taxYear),
                    nonCollecting,
                    inActive,
                    nextPeriodDue: nonCollecting || inActive ? 0.0 : null,
                    nextNextPeriodDue: nonCollecting || inActive ? 0.0 : null,
                    baseTax: nonCollecting || inActive ? 0.0 : null,
                    baseDue: nonCollecting || inActive ? 0.0 : null,
                    placeHolder: false,
                    taxDataSource: 'EDITOR',
                    asOfDate: new Date()
                });

                // Add notes immutably if not already present
                note.forEach(cur => {
                    const alreadyExists = account.accountNotes.some((el:any) => el.comment === cur.comment);
                    if (!alreadyExists) {
                        account.accountNotes.push({
                            sort: cur.sort,
                            comment: cur.comment,
                            bold: cur.bold,
                            orderId: orderId,
                            saveAsCanned: false,
                            yellowHighlight: cur.yellowHighlight,
                            redColor: cur.redColor,
                            relationalId: id
                        });
                    }
                });
            }

            // Update state immutably
            setCertificate(clonedCertificate);

            if (type === 'jurisdiction') {
                clonedCertificate = updateNationalSummarySectionRow(clonedCertificate, showAccount, index, taxYear, setCertificate);
                autoNationalCalculateSummaryRow(clonedCertificate, setCertificate, showAccount);
                if (setUpdateTotalTaxValue != null) {
                    setUpdateTotalTaxValue(true);
                }
            }
            // If updatedAccountIndexList is useState
            if (typeof setUpdatedAccountIndexList === 'function') {
                setUpdatedAccountIndexList((prev: number[]) => {
                    return prev.includes(showAccount) ? prev : [...prev, showAccount];
                });
            }

            setIsSavedResult(false);
            setShow(false);
        }
    }


    function selectJurisdiction(props: any) {
        return (
            <span
                className={jurisdictionName === props.row.values.name ? 'active cursor-pointer' : 'active cursor'}
                id={props.row.original.id + "1"}
            >{props.value}
            </span>
        );
    }

    const setJurisdiction = (row: any) => {
        setJurisdictionName(row['name']);
        setId(row['id']);
        setNonCollecting(row['nonCollecting']);
        isInActive(row['inActive']);
        setCollectorName(row['collector']['name']);
        setCollectorId(row['collector.id']);
        setTaxRateList(row['taxRates']);
        setNote(row['certificateNotes']);
    };
    const columns: DataTableColumn[] = [
        {
            label: "Jurisdiction",
            accessor: "name",
            cell: selectJurisdiction,
            filterOptions: [{
                filterModalOption: {
                    filterModalPlaceHolder: "Enter Name...",
                    filterModalKey: "name",
                    filterModalIcon: <FaMagnifyingGlass size={14} className={''}/>
                },
                overrideFilterLabel: " ",
                overrideFilterAccessor: "name"
            }]
        },
        {label: "Collector Name", accessor: "collector.name", cell: selectJurisdiction},
    ];

    return (
        <>
            <Modal
                title={`Jurisdiction Selector`}
                show={show}
                setShow={setShow}
                className="w-2/5 bg-text-0 rounded-lg shadow-lg"
                fields={
                    <Form onSubmit={handleSubmit} fields={
                        <>
                            {/* Modal Body */}
                            <div className="modal-body px-4 pt-4">
                                <DataTable
                                    columns={columns}
                                    actions={{
                                        fetchAction: useSearchAllJurisdictionQuery,
                                    }}
                                    defaultFilter={{
                                        pageNumber: 0,
                                        pageSize: 5,
                                        countyId: county,
                                        type: "picker"
                                    }}
                                    appendFilterToUrl={false}
                                    renderOptions={{
                                        skipButtonSectionRender: true,
                                        skipFilterButtonRender: true,
                                        skipPaginationRender: false,
                                        skipUserSettingRender: true
                                    }}
                                    defaultSortOptions={{
                                        accessor: "name",
                                        direction: "asc"
                                    }}
                                    rowSelectionOptions={{
                                        enableRowSelection: true,
                                        onSelectionChange: (selectedRow: Set<any>) => {
                                            const [row] = Array.from(selectedRow);
                                            if (row) {
                                                setJurisdiction(row)
                                            }
                                        },
                                    }}
                                />
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer border-t border-gray-300 px-4 py-2 flex justify-end gap-1">
                                <ButtonTray
                                    buttons={[
                                        {
                                            buttonProps: {
                                                btnText: "Cancel",
                                                onClick: () => setShow(false),
                                                type: "cancel",
                                            },
                                            buttonType: "button"
                                        },
                                        {
                                            buttonProps: {
                                                btnText: "Submit",
                                                type: "submit",
                                            },
                                            buttonType: "button",
                                        }
                                    ]}
                                    align={"end"}
                                    gap={2}
                                />
                            </div>
                        </>
                    }/>
                }
            />
        </>

    )
}
